<template>
  <section class="program-detal">
    <div class="container">
      <div class="columns">
        <div class="column">
          <div class="program-detal__subtitle">
            PROGRAM TV / DZIŚ, {{ formatDayTvProgram(Date()) }}, {{ formatDateTvProgram(Date()) }}
          </div>
          <div class="program-detal__title">{{ programDetail?.title }}</div>
          <div class="program-detal__legend">
            <span class="program-detal__legend-icons-live" v-if="currentOccurrenceProgram?.live">Na żywo</span>
            <div class="program-detal__additional">{{ currentYear(Date()) }}</div>
          </div>
        </div>
      </div>
      <div class="columns" v-if="isOccurrence">
        <div class="column">
          <div class="program-detal__navigation">
            <div class="program-detal__navigation-before">
              <template v-if="prevOccurrenceProgram">
                <app-link
                  class="program-detal__navigation__content"
                  :to="prevOccurrenceProgram.url"
                  :path-type="prevOccurrenceProgram.type"
                  :routing-data="prevOccurrenceProgram.routing_data"
                  v-if="isTablet"
                >
                  <span class="program-detal__navigation-time">wcześniej</span>
                  <span class="program-detal__navigation-hour">{{
                    formatDateToTime(prevOccurrenceProgram.date_start)
                  }}</span>
                  <span class="program-detal__navigation-desc">
                    {{ prevOccurrenceProgram?.title }}
                  </span>
                </app-link>
                <app-link
                  class="program-detal__navigation-mobile left"
                  :to="prevOccurrenceProgram.url"
                  :path-type="prevOccurrenceProgram.type"
                  :routing-data="prevOccurrenceProgram.routing_data"
                  v-else
                />
              </template>
            </div>
            <div class="program-detal__navigation-date">
              <span class="program-detal__navigation-day">
                DZIŚ, {{ formatDayTvProgram(Date()) }}, {{ formatDateTvProgram(Date()) }}
              </span>
              <span class="program-detal__navigation-hour">{{
                formatDateToTime(currentOccurrenceProgram.date_start)
              }}</span>
            </div>
            <div class="program-detal__navigation-after">
              <template v-if="nextOccurrenceProgram">
                <app-link
                  class="program-detal__navigation__content"
                  :to="nextOccurrenceProgram.url"
                  :path-type="nextOccurrenceProgram.type"
                  :routing-data="nextOccurrenceProgram.routing_data"
                  v-if="isTablet"
                >
                  <span class="program-detal__navigation-time">później</span>
                  <span class="program-detal__navigation-hour">{{
                    formatDateToTime(nextOccurrenceProgram.date_start)
                  }}</span>
                  <span class="program-detal__navigation-desc">
                    {{ nextOccurrenceProgram?.title }}
                  </span>
                </app-link>
                <app-link
                  class="program-detal__navigation-mobile right"
                  :to="nextOccurrenceProgram.url"
                  :path-type="nextOccurrenceProgram.type"
                  :routing-data="nextOccurrenceProgram.routing_data"
                  v-else
                />
              </template>
            </div>
          </div>
        </div>
      </div>
      <ProgramTvDetailContent :program="programDetail" :other-emissions="otherEmissions" />
    </div>
  </section>
</template>

<script setup>
import { useUtils } from '@/composables/useUtils'
import { useBreakpoint } from '@/composables/useBreakpoints'
import ProgramTvDetailContent from '@/components/program/ProgramTvDetailContent.vue'
import { computed, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useRoute } from 'vue-router'
import { useProgramsStore } from '@/stores/programs'
import AppLink from '@/components/layout/AppLink.vue'

const route = useRoute()
const { isTablet } = useBreakpoint()

const { formatDateTvProgram, formatDayTvProgram, formatDateToTime, currentYear } = useUtils()

const programsStore = useProgramsStore()
const {
  programDetail,
  otherEmissions,
  currentOccurrenceProgram,
  nextOccurrenceProgram,
  prevOccurrenceProgram
} = storeToRefs(programsStore)
const {
  fetchProgramDetails,
  fetchInstanceListProgram,
  fetchCurrentOccurrenceProgram,
  fetchNextOccurrenceProgram,
  fetchPrevOccurrenceProgram
} = programsStore

const isOccurrence = computed(() => route?.query?.o ?? undefined)

watch(
  () => route.params,
  () => {
    const programId = route.params.id
    fetchProgramDetails(programId)
    if (isOccurrence.value) {
      fetchCurrentOccurrenceProgram(isOccurrence.value)
      fetchInstanceListProgram(programId, [isOccurrence.value])
      fetchNextOccurrenceProgram(isOccurrence.value)
      fetchPrevOccurrenceProgram(isOccurrence.value)
    } else {
      fetchInstanceListProgram(programId)
    }
  },
  { immediate: true, deep: true }
)
</script>

<style lang="scss">
@import '@/assets/scss/views/program-tv-detail-page.scss';
</style>
